import { createContext } from 'react';

import type { StockLevelListItem } from './stockTypes';

/**
 * Opens the stock detail panel from a FIGURE in the Stock Levels table.
 *
 * <b>Product call, 02 Oct 2026</b>, in the reader's own words: *when cells with values greater
 * than 0, is clicked, trigger and display the stock profile*. A figure is the only thing on that
 * row a reader is actually looking at, and every one of them was inert — the whole row answered
 * to one anchor twenty columns away.
 *
 * <b>It is a CONTEXT rather than a prop on every column</b>, for the reason `AnchorCellContext`
 * is one: the columns are a module-level array shared by the table, the list view, the row
 * preview and the footer, and threading a callback through each of those is four chances for one
 * of them to pass a different handler — or none. Supplying the context is what makes a figure
 * live; a surface that does not provide it renders exactly what it rendered before.
 *
 * <b>Null is the ordinary case.</b> Every other surface that draws these columns writes nothing,
 * so the figures stay plain text there.
 */
export const StockFigureContext = createContext<((level: StockLevelListItem) => void) | null>(null);
